import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { LanguageService } from '@core/services/language.service';
import { RtlIconService } from '@core/services/rtl-icon.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'waki-frontend-v2';

  /** Instantiated here so `dir`/`lang` are on <html> before the first page paints. */
  private language = inject(LanguageService);
  private rtlIcons = inject(RtlIconService);

  constructor() {
    this.rtlIcons.init();
  }
}
